module.exports = __webpack_public_path__ + "static/media/axisMaxLogo.5b84c19f.png";